import Expandable from "../utils/classes/Expandable";

export default function (el) {
    const expandable = new Expandable(el);
    expandable.init();
}
